<div>
    <div class="data">{{config.message}}</div>
    <div class="dismiss">
        <button mat-icon-button (click)="snackBarRef.dismiss()">
            <mat-icon>close</mat-icon>
        </button>
    </div>
</div>